import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'
import curryRight from 'lodash/curryRight'
import includes from 'lodash/fp/includes'
import map from 'lodash/fp/map'
import last from 'lodash/fp/last'
import keys from 'lodash/fp/keys'
import filter from 'lodash/fp/filter'
import pick from 'lodash/fp/pick'
import { USER_ROLES } from '../constants'
import { getUser, getUserId, getUserName, getToken, hasUserRole, getBiLabsUrl } from '@layers-frontend/commons/store/selectors/user'
import { buildRegionalIntelUrl } from '../regionalIntel/regionalIntelUrl'

export { getUser, getToken, hasUserRole, getUserName, getBiLabsUrl }
export const getCustomers = get('customers')

export const getErrorLogin = pipe(getUser, get('errorLogin'))

export const getUserData = (state, key) => pipe(getUser, get(key))(state)

export const getFieldsProperties = state => {
  const statistics = curryRight(getUserData)('statistics')(state)
  const fieldsProperties = statistics.reduce((allProperties, currentProperty) => {
    const metadata = get('metadata')(currentProperty)
    const features = get('features')(metadata)
    const lastFeatureProperties = last(map('properties')(features))
    const fieldId = get('field_id')(lastFeatureProperties)

    return {
      ...allProperties,
      [fieldId]: allProperties[fieldId] ? [...allProperties[fieldId], lastFeatureProperties] : [lastFeatureProperties]
    }
  }, {})

  const fieldsIdsWithMoreThanThreeSnapshots = filter(fieldId => fieldsProperties[fieldId].length > 2)(keys(fieldsProperties))
  // const fieldsIdsWithMoreThanThreeSnapshots = uniqBy(fieldId => fieldsProperties[fieldId].length > 2)(keys(fieldsProperties))

  return pick(fieldsIdsWithMoreThanThreeSnapshots)(fieldsProperties)
}

export const hasUserCoordsInLoggerAuthorization = pipe(curryRight(getUserData)('roles'), includes(USER_ROLES.ROLE_COORDS_LOGGER))

// LAYI is gated on ROLE_WEB_LAYI: the floating widget, the chat page and its icon in the top bar.
// This only hides them — the chat service resolves the role itself and refuses a session without it.
export const canUseLayi = state => hasUserRole(state, USER_ROLES.ROLE_WEB_LAYI)

// Regional Intel (an external site) is gated on ROLE_REGIONAL_INTEL: its entry in the top bar. The site
// decides on its own side what the user may do there.
export const canUseRegionalIntel = state => hasUserRole(state, USER_ROLES.ROLE_REGIONAL_INTEL)

// The user's customer id, only when there is exactly one. Hasura joins `agro__customers` on
// agro__customer.id = user.id, so a farmer has one (with the user's own id) and agro users and
// cooperatives none.
export const getUserCustomerId = pipe(getUser, get('agro__customers'), customers =>
  Array.isArray(customers) && customers.length === 1 ? get('id')(customers[0]) : undefined
)

// The Regional Intel link, or null: with the role and a build that sets REACT_APP_REGIONAL_INTEL_URL
// (local builds leave it unset, so the entry stays hidden there). Read on every call, not at import.
export const getRegionalIntelUrl = state =>
  canUseRegionalIntel(state)
    ? buildRegionalIntelUrl({ baseUrl: process.env.REACT_APP_REGIONAL_INTEL_URL, userId: getUserId(state), customerId: getUserCustomerId(state) })
    : null
